// ============================================================
// ANIMATION / TWEEN SYSTEM
// ============================================================

import { lerp } from './utils.ts';

export type EaseType = 'easeOut' | 'bounce' | 'linear';

interface Tween {
  obj: Record<string, number>;
  start: Record<string, number>;
  end: Record<string, number>;
  dur: number;
  elapsed: number;
  ease: EaseType;
  onDone?: () => void;
}

export class Anim {
  tweens: Tween[] = [];

  add(
    obj: Record<string, any>,
    props: Record<string, number>,
    dur: number,
    ease?: EaseType,
    onDone?: () => void,
  ): void {
    const start: Record<string, number> = {};
    for (const k in props) start[k] = obj[k];
    this.tweens.push({
      obj,
      start,
      end: props,
      dur,
      elapsed: 0,
      ease: ease || 'easeOut',
      onDone,
    });
  }

  update(dt: number): void {
    for (let i = this.tweens.length - 1; i >= 0; i--) {
      const tw = this.tweens[i];
      tw.elapsed += dt;
      let t = Math.min(1, tw.elapsed / tw.dur);
      if (tw.ease === 'easeOut') t = 1 - (1 - t) * (1 - t);
      else if (tw.ease === 'bounce') t = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      for (const k in tw.end) tw.obj[k] = lerp(tw.start[k], tw.end[k], t);
      if (tw.elapsed >= tw.dur) {
        for (const k in tw.end) tw.obj[k] = tw.end[k];
        if (tw.onDone) tw.onDone();
        this.tweens.splice(i, 1);
      }
    }
  }

  get busy(): boolean {
    return this.tweens.length > 0;
  }

  clear(): void {
    this.tweens = [];
  }
}

/** Global animation instance */
export const anim = new Anim();
